import { render, staticRenderFns } from "./Compliance.vue?vue&type=template&id=28e9408c&scoped=true"
import script from "./Compliance.vue?vue&type=script&lang=js"
export * from "./Compliance.vue?vue&type=script&lang=js"
import style0 from "./Compliance.vue?vue&type=style&index=0&id=28e9408c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e9408c",
  null
  
)

export default component.exports